import Splide, { SlideComponent } from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';
import { MyTransition } from './splide-transition';

const commonGalleryOptions = {
    accessibility: true,
    drag: true,
    // @ts-ignore
    pagination: true,
    // @ts-ignore
    slideFocus: false,
    easing: 'linear',
    speed: 600,
    interval: 5000,
    focus: 0,
    padding: {
        left: '0rem',
        right: '0rem'
    },
    arrows: true,
    keyboard: 'focused',
    video: {
        // setting to true is currently required due to a bug in the splide video extension creating
        // the embed url with an empty "playlist" parameter which break YouTube embed link
        loop: false
    },
    classes: {
        pagination: 'splide__pagination gallery-pagination gallery-pagination-nums',
        page: 'splide__pagination__page gallery-page'
    },

}

const calloutGalleryOptions = (perPage: number) => ({
    perPage: 1,
    perMove: 1,
    padding: {
        left: '0rem',
        right: '0rem'
    },
    gap: '0rem',
    updateOnMove: true,
    autoHeight: true,
    omitEnd: true,
    video: {
        autoplay: true,
        loop: true,
        mute: true,
        volume: 0.0,
        hideControls:true,
    }
})

const gridGalleryOptions = (perPage: number) => ({
    perPage: perPage,
    perMove: perPage,
    gap: '2rem',
    breakpoints: {
        1280: {
            perPage: Math.max(1, Math.floor(perPage / 2)),
            perMove: Math.max(1, Math.floor(perPage / 2)),
            gap: '1.5rem',
        },
        767: {
            perPage: 1,
            perMove: 1,
            gap: '1rem',
        }
    },
    updateOnMove: true,
    autoHeight: true,
    omitEnd: true,
   

})


// Ignore the typescript issues on the pagination property and slideFocus, it's just incorrect typings from the library
export class Gallery {
    gallery: Splide;
    isTypeCallout: boolean;
    galleryOptions: any;//Refer to splide options documentationt for available choices
    autoStart: string;
    setInterval: string;
    progressBar: HTMLElement;
    galleryElement: HTMLElement;
    videoPlayButton: HTMLElement;
    videoPauseButton: HTMLElement;

    constructor(element: HTMLElement) {
        this.galleryElement = element;
        this.isTypeCallout = element.getAttribute('data-gallery-type') == "callout";
        this.videoPlayButton = element.querySelector('[data-splide-play-video]');
        this.videoPauseButton = element.querySelector('[data-splide-pause-video]');
        this.autoStart = element.getAttribute('data-autoplay') != null ? element.getAttribute('data-autoplay') : "";
        // This needs to be set to a obscenely large number due to an interval bug with Splide
        this.setInterval = element.getAttribute('data-interval') != null ? element.getAttribute('data-interval') : "1000000";
        this.setGalleryOptions();
        this.gallery = new Splide(element, this.galleryOptions);
        this.gallery.on('mounted', () => {
            this.arrowDisplay();
            if (this.isTypeCallout) {
                let activeSlide = this.gallery.Components.Elements.slides[this.gallery.index];
                this.updateTheme(activeSlide)
                Array.from(document.querySelectorAll('.splide__video__play')).forEach(elm => {
                    elm.classList.add('callout-video-button');
                    elm.innerHTML = `<span class="visually-hidden">Play</span>
                                <div class="svg-icon gallery-play"></div>`;
                });
                

            }
            setTimeout(() => {
                const playButtons = Array.prototype.slice.call(this.gallery.root.querySelectorAll('.media-gallery-item .splide__slide__container--has-video'));
                playButtons.forEach(playButton => {
                    const slide = playButton.closest('.splide__slide');
                    const slideTarget = slide.querySelector('[data-gallery-video]');
                    slideTarget.append(playButton);
                });

            }, 1000);//Forgive me, but no event to listen to find out when the playbuttons are loaded. Splide also isn't respecting the splide__slide__container for the playbutton target so I had to do it manually here :(
        });


        this.gallery.on('resized', () => {
            this.arrowDisplay();
            // resize video 
            if (this.isTypeCallout) {
                const videoSelector = ".is-playing .is-active .splide__video__wrapper";
                const playingVideoElement = document.querySelector(`${videoSelector} video`) || document.querySelector(`${videoSelector} iframe`);
                this.setDimensions(playingVideoElement);
            }
        });

        this.gallery.on('move', () => {
            this.gallery.root.classList.add('moving');
            if (this.isTypeCallout) {
                let activeSlide = this.gallery.Components.Elements.slides[this.gallery.index];
                this.updateTheme(activeSlide);
            }
        });

        this.gallery.on('moved', () => {
            this.gallery.root.classList.remove('moving');
        });

        this.gallery.on('video:play', () => {
            const videoSelector = ".is-playing .is-active .splide__video__wrapper";
            const playingVideoElement = document.querySelector(`${videoSelector} video`) || document.querySelector(`${videoSelector} iframe`);
            if (playingVideoElement) {
                playingVideoElement.setAttribute('title', playingVideoElement.closest('[data-video-title]').getAttribute('data-video-title'));
            }
            if (this.isTypeCallout) {
                Array.from(document.querySelectorAll('.splide__video__play')).forEach(elm => {
                    elm.innerHTML = `<span class="visually-hidden">Pause</span>
                                <div class="svg-icon gallery-pause"></div>`;
                });
              /*  const videoSelector = ".splide__video__wrapper";
                let videoIframes = Array.from(document.querySelectorAll(`${videoSelector} iframe`));
                let videoNative = Array.from(document.querySelectorAll(`${videoSelector} video`));
                const videoElements = videoNative.concat(videoIframes);
                videoElements.forEach(el => { this.setDimensions(el); });*/
                this.setDimensions(playingVideoElement);
            }

        });

        this.gallery.on('video:pause', () => {
            if (this.isTypeCallout) {
                Array.from(document.querySelectorAll('.splide__video__play')).forEach(elm => {
                    elm.innerHTML = `<span class="visually-hidden">Play</span>
                                <div class="svg-icon gallery-play"></div>`;
                });
            }
        });

        this.gallery.on('overflow', (isOverflow) => {
            this.gallery.options = {
                drag: isOverflow,
            };
        });

        this.gallery.mount({ Video }, MyTransition);
    }
    arrowDisplay = () => {
        const galleryArrows = this.gallery.Components.Arrows.arrows;
        if (galleryArrows.next && galleryArrows.prev) {
            const arrowsShouldBeHidden = galleryArrows.next.hasAttribute('disabled') && galleryArrows.prev.hasAttribute('disabled');
            galleryArrows.next.hidden = arrowsShouldBeHidden;
            galleryArrows.prev.hidden = arrowsShouldBeHidden;

        }
    }
    setGalleryOptions = () => {
        const perPage = this.galleryElement != null ? parseInt(this.galleryElement.getAttribute('data-grid-size')) : 4;
        const optionsToUse = this.isTypeCallout ? calloutGalleryOptions : gridGalleryOptions;

        const autoPlayOptions = {
            autoplay: this.autoStart.toString(),
            interval: this.setInterval.toString()
        }
        this.galleryOptions = {
            ...commonGalleryOptions,
            ...autoPlayOptions,
            ...optionsToUse(perPage)
        }
    }

    updateTheme = (slide: HTMLElement) => {
        this.galleryElement.parentElement.className = 'gallery media-gallery ' + slide?.getAttribute('data-theme');
    }
    setDimensions(video) {
        const headerWidth = video.closest('.splide__video').offsetWidth;
        const headerHeight = video.closest('.splide__video').offsetHeight;
        video.style.width = `${Math.max(headerWidth, (headerHeight * 16 / 9))}px`;
        video.style.height = `${Math.max((headerHeight), (headerWidth * 9 / 16))}px`;
    }
    
}